import React from 'react';
import Generator from '../components/Generator'; // or just paste your generator JSX here

const GeneratorPage = () => {
    return <Generator />;
};

export default GeneratorPage;
